import type { IAttributes, IDirective, INgModelController } from "angular";
import { module } from "angular";
import { utc } from "moment-timezone";

export default class ValidMomentDirective implements IDirective {
    public restrict = "A";

    public require = "ngModel";

    public priority: 1;

    public link = (scope: any, el: JQuery, attributes: IAttributes, ctrl: INgModelController) => {
        ctrl.$validators.moment = (modelValue?: string) => {
            if (ctrl.$isEmpty(modelValue)) {
                return true;
            }

            const modelValueAsMoment = utc(modelValue, scope.dateFormat);

            return modelValueAsMoment.isValid && modelValueAsMoment.isValid();
        };
    };
}

module("mmGui").directive("irValidMoment", () => new ValidMomentDirective());
